import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components/lib/Button";
import { useTranslation } from "react-i18next";

import "./style.scss";

const TRANSLATION_KEY = {
  START: "Start.string",
  STOP: "Stop.string",
  START_BUTTON_ENABLED: "StartButtonEnabled.string",
  START_BUTTON_DISABLED: "StartButtonDisabled.string",
  STOP_BUTTON_ENABLED: "StopButtonEnabled.string",
  STOP_BUTTON_DISABLED: "StopButtonDisabled.string",
};

export function StartStopButton(props) {
  const { t } = useTranslation();

  const commonClassName = "mc_settings_startstop_button";

  const stopBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--stop`
    : `${commonClassName} mc_button--stop`;

  const startBtnClassName = props.disabled
    ? `${commonClassName} mc_invalidBtn--start`
    : `${commonClassName} mc_button--start`;

  const startButtonAltText = props.disabled
    ? t(TRANSLATION_KEY.START_BUTTON_DISABLED)
    : t(TRANSLATION_KEY.START_BUTTON_ENABLED);

  const stopButtonAltText = props.disabled
    ? t(TRANSLATION_KEY.STOP_BUTTON_DISABLED)
    : t(TRANSLATION_KEY.STOP_BUTTON_ENABLED);

  return (
    <div className="mc_settings_startstop">
      <Button
        onClick={props.onClickStop}
        className={stopBtnClassName}
        aria-label={stopButtonAltText}
      >
        {t(TRANSLATION_KEY.STOP)}
      </Button>
      <Button
        onClick={props.onClickStart}
        className={startBtnClassName}
        aria-label={startButtonAltText}
      >
        {t(TRANSLATION_KEY.START)}
      </Button>
    </div>
  );
}

StartStopButton.propTypes = {
  /**
   * callback for when stop button is clicked
   */
  onClickStop: PropTypes.func,
  /**
   * callback for when start butto is pressed
   */
  onClickStart: PropTypes.func,
  /**
   * specifies if buttons are disabled
   */
  disabled: PropTypes.bool,
};

StartStopButton.defaultProps = {
  className: "",
};
